import styled from 'styled-components';

import {TextInput} from '../TextInput';

export const NumberTextInput = styled(TextInput).attrs({
  webProps: {type: 'number'},
})`
  /* Chrome, Safari, Edge, Opera */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    appearance: none;
    margin: 0;
  }

  /* Firefox */
  &[type='number'] {
    appearance: textfield;
  }
`;
